import React from "react";
import PropTypes from "prop-types";
import { gettext } from "web/script/modules/django-i18n";
import PrimaryButton from "../../buttons/primary-button/primary-button";
import LeadLink from "../../lead-link/lead-link";
import styles from "./product-gallery-more-details.css";

function MoreDetails({ retailer }) {
    const text = gettext("product.product_more_details_retailer_site", {
        retailer_name: retailer.name
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <img className={styles.image} src={retailer.image} alt={retailer.name} />
                <div className={styles.text}>{text}</div>
                <LeadLink
                    reason="image-gallery-view-details"
                    href={retailer.link}
                    openInNewTab={true}
                >
                    <PrimaryButton>{gettext("product.buy_area.visit_site_mobile")}</PrimaryButton>
                </LeadLink>
            </div>
        </div>
    );
}

export default MoreDetails;

const retailerShape = PropTypes.shape({
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
});

MoreDetails.propTypes = {
    retailer: retailerShape.isRequired
};
